import { TooltipContainer } from './style'

export default function StyledTooltip({
  title,
  placement = 'top',
  color = '#525252',
  children,
}) {
  return (
    <TooltipContainer title={title} placement={placement} color={color}>
      {children}
    </TooltipContainer>
  )
}
